const $doc = $(document);

const UPLOADCARE_PUB_KEY = "17e6328bac29ad4f6365";
const BASE_UPLOAD_URL = "https://upload.uploadcare.com/base/?jsonerrors=1";
const INFO_URL = "https://upload.uploadcare.com/info/";
const formatBytes = (bytes)=>{
  if (!bytes && bytes !== 0) return '';
  const k = 1024, u = ['B','KB','MB','GB','TB'];
  const i = Math.floor(Math.log(bytes)/Math.log(k));
  return (bytes/Math.pow(k,i)).toFixed(2) + ' ' + u[i];
};
// Clone your template (#mrk-image-item)
function cloneMrkTemplate(){
  const tplEl = document.getElementById('mrk-image-item');
  if (!tplEl) return null;

  if (tplEl.tagName.toLowerCase() === 'template' && tplEl.content && tplEl.content.firstElementChild){
    return $(tplEl.content.firstElementChild).clone(true, true);
  }
  return $(tplEl).clone(true, true).removeAttr('id').show();
}
function updateQuantity(){
  var quantity = 0;
  $('.mrk-selected-image-quantity input').each(function(){
    quantity = quantity + Number($(this).val())
  });
  $('.mrk-selected-count').html(quantity);
  var selected_quantity = Number($('[name="mrk-quantity"]:checked').val());
  if(quantity > selected_quantity){
    $('[name="mrk-quantity"]').each(function(){
      var qty = Number($(this).val());
      if(qty <= quantity){
        $(this).prop('checked', true);
      }
    });
    $('.mrk-total-count').html($('[name="mrk-quantity"]:checked').val())
  }
  return quantity;
}
function buildUploadkitURL(fileData) {
  const base = "https://cdn.shopify.com-uploadkit.app/s/files/1/0033/4807/0511/files/download";
  const id = fileData.file_id;
  const uu = fileData.uuid;
  const wi = fileData.image_info.width;
  const he = fileData.image_info.height;
  const fi = btoa(fileData.filename); // filename base64
  const mi = btoa(fileData.mime_type); // mime type base64
  const up = id.slice(0, 6); // first 6 chars

  return `${base}?id=${id}&uu=${uu}&mo=&fi=${fi}&wi=${wi}&he=${he}&mi=${mi}&up=${up}&image=true`;
}
// Upload one file, return a Promise resolving to {file, url, id}
function uploadFile(file){
  return new Promise((resolve, reject)=>{
    let fd = new FormData();
    fd.append("UPLOADCARE_PUB_KEY", UPLOADCARE_PUB_KEY);
    fd.append("UPLOADCARE_STORE", "auto");
    fd.append("source", "local");
    fd.append("file_name", file.name);
    fd.append("file", file, file.name);

    $.ajax({
      url: BASE_UPLOAD_URL,
      method: "POST",
      processData: false,
      contentType: false,
      data: fd,
      success: function(res){
        const fileId = res.file;

        const params = new URLSearchParams({
          jsonerrors: "1",
          file_id: fileId,
          pub_key: UPLOADCARE_PUB_KEY,
          wait_is_ready: "1",
          _: String(Date.now())
        });

        $.getJSON(`${INFO_URL}?${params.toString()}`, function(info){
          const fileUrl = `https://ucarecdn.com/${fileId}/-/resize/300x/`;
          console.log("Uploaded:", info);
          const download_url = buildUploadkitURL(info);
          resolve({ file, url: fileUrl, id: fileId, info, download_url });
        }).fail(reject);
      },
      error: reject
    });
  });
}
window.mrkFiles = [];

function updateFiles(){
  // clear container first
  $('.mrk-selected-images-wrapper').empty();

  window.mrkFiles.forEach((item)=>{
    const {file, url} = item;
    const $item = cloneMrkTemplate();
    if (!$item) return;
    $item.attr('uid', item.id).attr('url', item.download_url);
    $item.find('.mrk-image-preview img').attr('src', url).attr('alt', file.name);
    $item.find('.mrk-selected-image-title').text('Image'); //file.name
    $item.find('.mrk-selected-image-size').text(formatBytes(file.size) || '');

    $('.mrk-selected-images-wrapper').append($item);
  });
  updateQuantity()
}
(function($){
  // When user selects files → upload them all & store in window.mrkFiles
  $doc.on('change', '.mrk-selected-files', async function(){
    if (this.files && this.files.length){
      $('.mrk-loader-wrapper').css('display', 'flex');
      const files = Array.from(this.files);

      for (let f of files){
        try {
          const uploaded = await uploadFile(f);
          window.mrkFiles.push(uploaded);
        } catch(err){
          console.error("Upload failed:", err);
        }
      }

      // trigger popup open
      $('.mrk-loader-wrapper').hide();
      $('.mrk-open-popup').trigger('click');
      updateFiles()
    }
  });

  // After popup actually opens, build preview items from window.mrkFiles
  $doc.on('mrkPopupOpened', function(){
    if (!window.mrkFiles.length) return;
    updateFiles();
    $('.mrk-total-count').html($('[name="mrk-quantity"]:checked').val())
  });
  $(document).on('click', '.mrk-minus-btn', function(e){
    e.preventDefault();
    const $wrap = $(this).closest('.mrk-quantity-wrapper');
    const $inp  = $wrap.find('[name="quantity"]');
    let val = parseInt($inp.val(), 10) || 1;
    let min = parseInt($inp.attr('min'), 10) || 1;
    if (val > min) $inp.val(val - 1).trigger('change');
    updateQuantity()
  });

  $(document).on('click', '.mrk-plus-btn', function(e){
    e.preventDefault();
    var total = Number($('[name="mrk-quantity"]:checked').val());
    var selected = updateQuantity();
    const $wrap = $(this).closest('.mrk-quantity-wrapper');
    const $inp  = $wrap.find('[name="quantity"]');
    let val = parseInt($inp.val(), 10) || 1;
    $inp.val(val + 1).trigger('change'); //if (total > selected) 
    updateQuantity()
  });

  $(document).on('click', '.mrk-select-more-files', function(e){
    $('.mrk-selected-files').click()
  });
  $(document).on('click', '.mrk-remove-all', function(e){
    window.mrkFiles = [];
    $('.mrk-close-btn').click()
  });
  $(document).on('click', '.mrk-main-popup-open-btn', function(e){
    if(window.mrkFiles.length){
      $('.mrk-open-popup').click()
    }else{
      $('.mrk-selected-files').click();
    }
    
  });
  $(document).on('change', '.mrk-selected-image-variants-wrapper select', function(){
    const $card = $(this).closest('.mrk-selected-image-item');

    // Collect all selected values in correct order
    const selected = $card.find('.mrk-selected-image-variants-wrapper select')
      .get()
      .sort((a,b)=> (parseInt(a.dataset.position)||0) - (parseInt(b.dataset.position)||0))
      .map(el => $(el).val());

    // Find matching variant from global mrkVariants
    let variantId = null;
    if (Array.isArray(window.mrkVariants)) {
      for (const v of window.mrkVariants) {
        if (JSON.stringify(v.options.map(o => o.toLowerCase().trim())) === JSON.stringify(selected.map(o => o.toLowerCase().trim()))) {
          variantId = v.id;
          break;
        }
      }
    }

    // Set variant id attribute on the card
    if (variantId) {
      $card.attr('variant', variantId);
    } else {
      $card.removeAttr('variant');
    }
  });
  $(document).on('click', '.mrk-image-remove-btn', function(e){
    e.preventDefault();

    const $card = $(this).closest('.mrk-selected-image-item');
    const uid   = $card.attr('uid') || null;

    if (!uid) {
      console.warn("No UID found on card:", $card);
      $card.remove();
      return;
    }

    // Filter out this file from global mrkFiles
    if (Array.isArray(window.mrkFiles)) {
      window.mrkFiles = window.mrkFiles.filter(f => f.id !== uid && f.info?.uuid !== uid);
    }

    // Remove the card itself
    $card.remove();

    console.log("Removed file with UID:", uid);
    console.log("Updated mrkFiles:", window.mrkFiles);
  });
  $(document).on('click', '.mrk-done-all', function(e){
    e.preventDefault();
    var total = Number($('[name="mrk-quantity"]:checked').val());
    var selected = updateQuantity();
    // if(total > selected){
    //   alert(`Please select total quantity of ${total}, you select ${selected}`);
    //   return;
    // }
    const $bucket = $('<div/>'); // temp container for generated inputs

    $('.mrk-selected-image-item').each(function(index){
      const $card = $(this);
      const variant = $card.attr('variant') || '';                 // e.g. "51983203336525"
      const url = $card.attr('url') || $card.data('url') || ''; // CDN URL
      const qtyStr = $card.find('[name="quantity"]').first().val();
      const quantity = Math.max(1, parseInt(qtyStr, 10) || 1);

      $bucket.append(
        $('<input>', { type:'hidden', name:`items[${index}][id]`, value: variant }),
        $('<input>', { type:'hidden', name:`items[${index}][quantity]`, value: quantity }),
        $('<input>', { type:'hidden', name:`items[${index}][properties[Photo Upload]]`, value: url })
      );
    });
    $('.mrk-selected-notice').html(`(${$('.mrk-selected-image-item').length}) Photos Uploaded, (${selected}) Air Fresheners in Total`).show();
    $('.mrk-hidden-inputs').html($bucket.html());
    $('.mrk-close-btn').click();
    $('[name="id"]').prop('disabled', true)
  });
})(jQuery);

